import { homePage } from "../pages/homePage";
import { searchPage } from "../pages/searchPage";
import { notePage } from "../pages/notePage";
import { createNotePage, editNotePage } from "../pages/editPage";
import type { Route } from "./router";

export const routes: readonly Route[] = [
  { pattern: "/", factory: homePage },
  { pattern: "/search", factory: searchPage },
  { pattern: "/new", factory: createNotePage },
  { pattern: "/notes/:id", factory: notePage },
  { pattern: "/notes/:id/edit", factory: editNotePage },
];
